import {
  ServiceInvoiceType,
  supportAiSubscriptionInvoiceSchema,
  supportAiUsageInvoiceSchema,
  supportBaseInvoiceSchema,
  supportVoiceSubscriptionInvoiceSchema,
  supportVoiceUsageInvoiceSchema,
} from "@redotech/redo-billing-common/service-invoice";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getSupportBillingInvoices = {
  name: "getSupportBillingInvoices" as const,
  input: z.object({
    invoiceTypes: z.array(createEnum(ServiceInvoiceType)).optional(),
  }),
  output: z.object({
    supportBaseInvoices: z.array(supportBaseInvoiceSchema),
    supportAiInvoices: z.array(
      z.union([
        supportAiSubscriptionInvoiceSchema,
        supportAiUsageInvoiceSchema,
      ]),
    ),
    supportVoiceInvoices: z.array(
      z.union([
        supportVoiceSubscriptionInvoiceSchema,
        supportVoiceUsageInvoiceSchema,
      ]),
    ),
  }),
};
